import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import Flash from "../flash/Flash.jsx"
import { PlatformPolicyOptionNameByValue, PlatformPolicyRestrictionNameByValue } from '../../repo/PlatformPoliciesRepo.js'

export default function AdminPlatformPoliciesShow({platformPolicy, tournament, status}) {
  const [flashMessage, setFlashMessage] = useState("")

  useEffect(() => {
    if (status === "created") {
      setFlashMessage("Match was successfully created")
    } else if (status === "updated") {
      setFlashMessage("Match was successfully updated")
    }

    window.history.replaceState(null, "Admin - Platform Policy" , '/cocofantoelefanto/tournaments/' + platformPolicy.tournament_id + '/platform-policies/' + platformPolicy.id)
  }, [platformPolicy, status])

  return(
    <>
      <h1>Show Platform Policy: {tournament.name} {tournament.edition}</h1>
      {flashMessage !== "" && (
        <Flash message={flashMessage} type="success"/>
      )}

      <div className="flex flex-col mt-4">
        <div key="platformPolicy_option" className={`flex flex-row mt-4`}>
          <b>Plataforma:</b>
          <span className="ml-4">{ PlatformPolicyOptionNameByValue(platformPolicy.platform_name) }</span>
        </div>

        <div key="platformPolicy_restriction" className={`flex flex-row mt-4`}>
          <b>Restrição:</b>
          <span className="ml-4">{ PlatformPolicyRestrictionNameByValue(platformPolicy.restriction) }</span>
        </div>
      </div>

      <div id="actions" className="w-full pt-4 mt-4 space-x-2">
        <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${platformPolicy.tournament_id}/platform-policies/${platformPolicy.id}/edit`}>Edit Platform Policy</Link>
        <span>|</span>
        <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${platformPolicy.tournament_id}/platform-policies`}>Back to Platform Policies</Link>
        <span>|</span>
        <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${platformPolicy.tournament_id}/platform-policies/new`}>Create New Platform Policy</Link>
      </div>

    </>
  )
}
